"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var KeyFeaturesSlider = /** @class */ (function () {
    function KeyFeaturesSlider() {
        this.$owl = $('.strengths__carousel');
        this.initCarousel();
    }
    KeyFeaturesSlider.prototype.initCarousel = function () {
        this.$owl.owlCarousel({
            items: 3,
            slideSpeed: 2000,
            nav: true,
            autoplay: true,
            dots: true,
            loop: false,
            navText: [
                '<img src="/app/themes/tedee/assets/images/arrow-previous_org.svg" class="strengths__prev" alt="prev arrow">',
                '<img src="/app/themes/tedee/assets/images/arrow-next_org.svg" class="strengths__next" alt="next arrow">'
            ],
            responsive: {
                0: {
                    items: 1
                },
                768: {
                    items: 2,
                },
                1024: {
                    items: 3,
                    nav: false
                }
            }
        });
    };
    return KeyFeaturesSlider;
}());
exports.default = KeyFeaturesSlider;
